import PropTypes from "prop-types";
import styles from "./upgradeInfoBar.module.scss";
import CTAButton from "../CTAButton/CTAButton"
import { componentResize } from "../../../utils/helperServices";

const UpgradeInfoBar = props => {
  const imgSize = 17.5;
  const isMobile = componentResize();

  const renderType = () => {
    switch (props.type) {
      case "info":
        return styles["upgrade-check-bar-info"]
      default:
        return styles["upgrade-check-bar-success"]
    }
  }
  const bannerTypeClass = renderType();

  return (
    <div className={`d-flex ${styles["upgrade-check-bar"]} ${bannerTypeClass} ${props.className ? " " + props.className : ""}`}>
      <div className="d-flex">
        {!isMobile && (<svg xmlns="http://www.w3.org/2000/svg" width={imgSize} height={imgSize} fill="none" viewBox="0 0 40 41" className={styles["info-img"]}>
          <path fill="currentColor" fillRule="evenodd" d="M36.634 20.5c0 9.187-7.447 16.634-16.634 16.634-9.186 0-16.633-7.447-16.633-16.634 0-9.186 7.447-16.633 16.633-16.633 9.187 0 16.634 7.447 16.634 16.633zM21.2 13.21c0 .893-.724 1.617-1.617 1.617s-1.617-.724-1.617-1.617.724-1.617 1.617-1.617 1.617.724 1.617 1.617zM18.8 26.8v-7.6h-.467c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2H20c.663 0 1.2.538 1.2 1.2v8.8h.467c.663 0 1.2.538 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-3.333c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2h.466z" clipRule="evenodd" />
          <mask id="nauuhkizpa" width="34" height="35" x="3" y="3" maskUnits="userSpaceOnUse">
            <path fill="#fff" fillRule="evenodd" d="M36.634 20.5c0 9.187-7.447 16.634-16.634 16.634-9.186 0-16.633-7.447-16.633-16.634 0-9.186 7.447-16.633 16.633-16.633 9.187 0 16.634 7.447 16.634 16.633zM21.2 13.21c0 .893-.724 1.617-1.617 1.617s-1.617-.724-1.617-1.617.724-1.617 1.617-1.617 1.617.724 1.617 1.617zM18.8 26.8v-7.6h-.467c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2H20c.663 0 1.2.538 1.2 1.2v8.8h.467c.663 0 1.2.538 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-3.333c-.663 0-1.2-.537-1.2-1.2 0-.662.537-1.2 1.2-1.2h.466z" clipRule="evenodd" />
          </mask>
          <g mask="url(#nauuhkizpa)">
            <path fill="#ffffff" d="M0 0.5H40V40.5H0z" />
          </g>
        </svg>
        )}
        <span className={`${styles.message}`}>{props.message}</span>
      </div>
      {props.btnLabel && (<CTAButton className={`${styles.ctaBtn}`} variant={"link white"} handleClick={props.btnHandler} id={props.id}><span className="d-sm-inline-block d-md-none d-lg-none">{props.btnLabel}</span></CTAButton>)}
    </div>
  );
};

UpgradeInfoBar.defaultProps = {
  className: "",
  type: "success",
}

UpgradeInfoBar.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  btnLabel: PropTypes.string,
  btnHandler: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(["success", "info"])
};

export default UpgradeInfoBar;
